import { BreakpointObserver, Breakpoints, BreakpointState } from '@angular/cdk/layout';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import { DxDropDownButtonComponent } from 'devextreme-angular';
import { BehaviorSubject, filter, Subscription, takeUntil } from 'rxjs';
import { MachineInfo, MachineOwner } from 'src/api/generated';
import { MachineInfoMainService } from 'src/app/shared/services/machine-info.service';
import { MachineOwnerService } from 'src/app/shared/services/owner.service';
import { RemoteDataWrapperService } from '../../shared/services/remote-data/remote-data-wrapper.service';
import { BaseComponent } from '../../core/abstract/base.component';

@Component({
  templateUrl: './current-machine.component.html',
  styleUrl: './current-machine.component.scss'
})
export class CurrentMachineComponent extends BaseComponent implements OnInit {
  dropDownButton: DxDropDownButtonComponent['instance'] | undefined;
  actualMachine: MachineInfo | undefined;
  machineOwner: MachineOwner | undefined;
  isSmallScreen: boolean = false;
  faBars = faBars;
  id: string | undefined;
  selectedIndex: number = 0;
  supplierState: boolean | null = null;

  public firstMachineId$: BehaviorSubject<string | undefined> = new BehaviorSubject<string | undefined>(undefined);

  private _supplierStateSub?: Subscription;

  constructor(
    private _miSvc: MachineInfoMainService,
    private _oSvc: MachineOwnerService,
    private breakpointObserver: BreakpointObserver,
    private route: ActivatedRoute,
    private router: Router,
    private readonly remoteDataWrapperService: RemoteDataWrapperService
  ) {
    super();
    this.selectedIndex = parseInt(sessionStorage.getItem('currentMachineTabIndex') || '0');
  }

  ngOnInit() {
    // Listen for navigation events to this route
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      filter(() => this.router.url.includes('/current-machine') || this.router.url.includes('/machine/')),
      takeUntil(this.unSubscriber)
    ).subscribe(() => {
      this.validateAndLoadMachine();
    });

    // Initial load
    this.validateAndLoadMachine();

    // Breakpoint observer
    this.breakpointObserver
      .observe([Breakpoints.HandsetPortrait])
      .subscribe((state: BreakpointState) => {
        this.isSmallScreen = state.matches;
      });
  }


  private validateAndLoadMachine(): void {
    this.route.params.subscribe(params => {
      this.id = params['id'];
    });

    if (!this.id) {
      // No ID in route, so we're loading the "Current Machine"
      this._miSvc.getOneMachine(this._miSvc.CurrentMachineId).subscribe({
        next: machine => {
          this.actualMachine = machine;
          this._subSupplierState(machine.Name ?? "");
          this.getOwner();
        },
        error: err => {
          if (err.status === 404) {
            //Machine not found, we set the first
            this._miSvc.getAllMachines().subscribe({
              next: (m) => {
                if (m.data && m.data.length > 0) {
                  if (this._miSvc.CurrentMachineId !== '-1') {
                    this.actualMachine = m.data.find(m => m.Id === this._miSvc.CurrentMachineId) ?? m.data[0];
                    this._subSupplierState(this.actualMachine?.Name ?? "");
                  } else {
                    this.actualMachine = m.data[0];
                    this._subSupplierState(this.actualMachine?.Name ?? "");
                  }
                  this._miSvc.ActualMachine = this.actualMachine;
                  this.getOwner();
                }
              },
              error: (err) => {
                console.error(err);
              }
            })
          }
        }
      });
    } else {
      this._miSvc.ActualMachineId = this.id;
      this._miSvc.getOneMachine(this.id).subscribe({
        next: (m) => {
          this._miSvc.ActualMachine = m;
          this.actualMachine = m;
          this._subSupplierState(this.actualMachine?.Name ?? "");
          this.getOwner();
        },
        error: (err) => {
          console.error(err);
        }
      })
    }
  }

  private _subSupplierState(machineName: string): void {
    if (machineName) {
      this.remoteDataWrapperService.watchRemoteDataUpdates(machineName, true);
      this._supplierStateSub?.unsubscribe();
      this._supplierStateSub = this.remoteDataWrapperService.getSupplierState(machineName).pipe(takeUntil(this.unSubscriber)).subscribe(val => {
        this.supplierState = val;
      });
    }
  }

  public get MiSvc(): MachineInfoMainService {
    return this._miSvc;
  }

  public getOwner(): void {
    this.firstMachineId$.next(this.actualMachine?.Id);
    let owners = this._oSvc.AllOwners.filter(e => e.Id == this.actualMachine?.OwnerId);
    if (owners.length > 0) {
      this.machineOwner = owners[0];
    }
  }

  public changeSelectTabIndex(index: number): void {
    sessionStorage.setItem('currentMachineTabIndex', index.toString());
  }
}
